import "./_text-image-styles.scss";

 import './text-image';
